<template>
    <div>
        
        Her kan du angive hvilke tidsregistreringstyper, der IKKE skal tælle med i eksempelvis udregningen af medarbejdernes tid hos kunderne.
        <br><br>

        <div class="placeholder">
            <div class="placeholder__heading">
                Tidsregistreringstyper ({{ rows.length > 0 ? rows.length : '' }})
            </div>
            <div class="placeholder">
                
                <vue-good-table
                    :columns="columns"
                    :rows="rows"
                    :searchOptions="searchOptions"
                    :paginationOptions="paginationOptions"
                    :sortOptions="sortOptions"
                    styleClass="vgt-table"
                    v-if="!loading"
                >
                    <div slot="emptystate">
                        Ingen data ...
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div v-if="props.column.field == 'hours_last_year'">
                            {{ props.row.hours_last_year | number }}
                        </div>
                        <div v-else-if="props.column.field == 'action'">
                            <input type="checkbox" v-model="props.row.used_for_calculation" @change="update(props.row)" />
                            &nbsp;
                            <span v-if="props.row.used_for_calculation">
                                Synlig
                            </span>
                            <span v-else>
                                Skjult
                            </span>
                            <!--<div v-if="props.row.used_for_calculation">
                                <button @click="update(props.row, false)">
                                    Deaktiver
                                </button>
                            </div>
                            <div v-else>
                                <button @click="update(props.row, true)">
                                    Aktiver
                                </button>
                            </div>-->
                        </div>
                        <div v-else :title="props.formattedRow[props.column.field]">
                            {{ props.formattedRow[props.column.field] }}
                        </div>
                    </template>
                </vue-good-table>

                <box-loading height="350" v-else />

            </div>
        </div>

    </div>
</template>

<style lang="scss" scoped>
button {
    background: #172b43;
    color: #fff;
    padding: 2px 4px;
    border-radius: 4px;
}
</style>

<script>
import * as timeloggingTypesService from '@/services/timeloggingTypesService'

export default {
    data () {
        return {
            columns: [
                { label: 'Navn', field: 'title', type: 'string' },
                { label: 'Antal timer det sidste år', field: 'hours_last_year', type: 'number' },
                { label: 'Vis/skjul', field: 'action' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 100,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'title',
                    type: 'asc'
                }
            },
            rows: [],
            loading: false
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            let params = {}
            timeloggingTypesService.list(params, (response) => {
                this.rows = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        update (row) {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.')
                return
            }
            const params = {
                used_for_calculation: row.used_for_calculation ? 1 : 0
            }
            timeloggingTypesService.update(row.id, params, (response) => {
                console.log(response)
                row.used_for_calculation = Number(response.data.used_for_calculation)
                this.$toastr('success', 'Indstillingen blev opdateret', 'Sådan!')
            }, (err) => {
                console.log(err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// timeloggingTypesSettings.vue?ebe92eda